import React from 'react'

const AccoutSettingsContext = React.createContext();

export default AccoutSettingsContext;
